import { render } from "./returnList.vue?vue&type=template&id=95c202f2&scoped=true"
import script from "./returnList.vue?vue&type=script&lang=js"
export * from "./returnList.vue?vue&type=script&lang=js"

import "./returnList.vue?vue&type=style&index=0&id=95c202f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95c202f2"]])

export default __exports__